import { createContext } from "react";
import { PaneDimensions } from "./PaneDimensions";

export const PaneDimensionsContext = createContext<PaneDimensions | null>(null);
